module.exports = __webpack_public_path__ + "media/dashboard/assets/images/profile_hotkey-cf88ffd25b90c5bf8be50d3fc955c520.svg";